@if (timeline) {
  <section class="timeline-items scroll-section" [id]="add_padding ? 'extra-padding' : ''">
    @for (item of timeline; track item) {
      @if (isScheduleEntry(item.item_type, item.card_type)) {
        <app-timeline-schedule-entry [ngStyle]="cardBorder(item.card_type)" [timeline_item]="item">
        </app-timeline-schedule-entry>
      }
      @if (isCard(item.item_type, item.card_type) && ensureData(item)) {
        <app-timeline-card
          [ngStyle]="cardBorder(item.card_type)"
          [style.backgroundImage]="handleBackground(item)"
          [timeline_item]="item"
          class="bleachr-card"
          [timeline_id]="timeline_id"
        ></app-timeline-card>
      }
      @if (isComponent(item.item_type, item.card_type) && ensureData(item)) {
        <app-timeline-component [timeline_item]="item" [timeline_id]="timeline_id"></app-timeline-component>
      }
    }
    <div style="height: 1rem" appIntersectionObserver #intersection="intersection" (isIntersecting)="isIntersecting($event)" [isContinuous]="true"></div>
  </section>
}
